import LandingPage from 'src/components/LandingPage/LandingPage';
import { connect } from 'react-redux';
import { FrameworkActionCreator, VehiclesActionCreator, NewVehicleActionCreator, AppointmentActionCreator, AdditionalServicesActionCreator, WebOpsActionCreator, MenusActionCreator, CustomerActionCreator, RMTimesActionCreator, SpecsActionCreator, RepairOrdersActionCreator, ROHistoryActionCreator } from 'src/store/states';
import { IStoreState } from 'src/store';


const mapStateToProps = (state: IStoreState) => ({
    rtsToken: state.Framework.rtsToken,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    viewMode: state.Framework.viewMode,
    specData: state.Specs.specs,
    theme: state.Framework.theme,
    addlTrackToken: state.Framework.addlTrackToken,
    resetPassFlag: state.Framework.resetPassFlag,
    addlTrackVin: state.Framework.addlTrackVin,
    addlTrackYear: state.Framework.addlTrackYear,
    addlTrackMake: state.Framework.addlTrackMake,
    addlTrackModel: state.Framework.addlTrackModel,
    store: state.Framework.store,
    branch: state.Framework.branch,
    decodeData: state.Vehicles.decodedData,
    optionsSelected: state.NewVehicle.NewVehicle,
    vehicles: state.Vehicles.vehicles,
    specProfile: state.Framework.specProfile,
    oemFirstName: state.Framework.oemFirstName,
    oemLastName: state.Framework.oemLastName,
    oemEmail: state.Framework.oemEmail,
    oemPhone: state.Framework.oemPhone,
    oemError: state.Framework.oemError,
    custInfo: state.Customer!['Customer'],
    errMsg: state.Customer!.errMsg,
    loadNameId: state.Framework.loadNameId,
    loadVin: state.Framework.loadVin,
    loadRO: state.Framework.loadRO,
    loadAppt: state.Framework.loadAppt,
    apptList: state.Appointment.ViewApptList,
    apptCustId: state.Appointment.ApptCust.custNameId,
    serviceDocsFlag: state.Framework.serviceDocsFlag,
    toyLexStart: state.Framework.toyLexStartSent,
    menusReturnCode: state.Menus.allMenus.returnCode,
    previousToken: state.Framework.previousToken,
    logId: state.Specs.specs?.logId,
    countryCode: state.Framework.dealerCountry,
    languageCode: state.Framework.dealerLangCode,
    locale: state.Framework.locale,
    langOption: state.Specs.specs?.langOption ?? '',
    goToLoginFlag: state.Framework.goToLoginFlag,
    checkRepairStatusFlag: state.Framework.checkRepairStatusFlag,
    viewServiceHistFlag: state.Framework.viewServiceHistFlag,
    repairOrders: state.RepairOrders.RepairOrders,
    sysId: state.Framework.sysId ?? '',
    identityVerified: state.Customer.identityVerified,
    verifyingIdentity: state.Customer.verifyingIdentity,
    isCookiesEnabled: state.Framework.isCookiesEnabled,
    miscdec: state.Framework.miscdec,
    osdVerifyIdentityEnabled: state.Specs.serviceDocsSpecs?.osdVerifyIdentityFlag,
    serviceDocsSpecs: state.Specs.serviceDocsSpecs,
    previewFlag: state.Framework.previewFlag,
    viewRepairStatusFlag: (state.RepairOrders.RepairOrders && !state.Framework.loadAppt && state.Framework.loadRO &&
            state.Framework.checkRepairStatusFlag !== 'Y') ? true : false,
    waitOnMC: state.Framework.waitOnMC,
    waitOnRecall: state.Framework.waitOnRecall,
    vwDeepLinkMileage: state.Framework.vwDeepLinkMileage,
    vinCustReturned: state.Customer.vinCustReturned,
    inquiryReturned: state.AdditionalServices.recallData.inquiryReturned,
    inquiryError: state.AdditionalServices.recallData.inquiryError,
    recalls: state.AdditionalServices.recallData.recalls,
    MCReturned: state.AdditionalServices.maintContractData.MCReturned,
    MCError: state.AdditionalServices.maintContractData.MCError,
    maintContracts: state.AdditionalServices.maintContractData.maintContracts,
    recom: state.AdditionalServices.allServices.recom,
    selectedVehicle: state.Vehicles.selectedVehicle !== undefined ? state.Vehicles.selectedVehicle : '',
    sessionId: state.Framework.sessionId,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
});

const mapDispatchToProps = {
    clearMainPanes: FrameworkActionCreator.clearMainPanes,
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    pushToLeftPane: FrameworkActionCreator.pushToLeftPane,
    setViewMode: FrameworkActionCreator.acSetViewMode,
    getAddlTrackCustomerInfo: FrameworkActionCreator.getAddlTrackCustomerInfo,
    // getResetPassCustomerInfo: FrameworkActionCreator.getResetPassCustomerInfo,
    clearDecodeData: VehiclesActionCreator.ClearDecodeData,
    decodeVin: VehiclesActionCreator.DecodeVin,
    onAddNewVehicle: NewVehicleActionCreator.AddNewVehicle,
    updateAppVehicle: AppointmentActionCreator.UpdateApptVehicle,
    addVehicle: VehiclesActionCreator.AddVehicle,
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    clearAdditionalServices: AdditionalServicesActionCreator.ClearAdditionalServices,
    UpdateApptOps: AppointmentActionCreator.UpdateApptOps,
    getAdditionalServices: AdditionalServicesActionCreator.GetAdditionalServices,
    getRecalls: AdditionalServicesActionCreator.GetRecalls,
    getApptOps: WebOpsActionCreator.GetApptOps,
    getMenus: MenusActionCreator.GetMenus,
    customerSearch: CustomerActionCreator.CustomerSearch,
    vinCustomerSearch: CustomerActionCreator.VINCustSearch,
    onAppCustUpdate: AppointmentActionCreator.UpdateApptCust,
    onCustUpdate: CustomerActionCreator.UpdateCustInfo,
    clearError: CustomerActionCreator.CustomerClearError,
    getVehicles: VehiclesActionCreator.GetVehicles,
    setVehNextAppt: VehiclesActionCreator.SetVehNextAppt,
    getCustAppts: AppointmentActionCreator.GetCustAppts,
    updateApptDate: AppointmentActionCreator.UpdateApptDate,
    setToyLexStart: FrameworkActionCreator.SetToyLexStart,
    getInvalidDates: RMTimesActionCreator.GetInvalidDates,
    determineDept: AppointmentActionCreator.DetermineDept,
    getDeptSpecs: SpecsActionCreator.GetDeptSpecs,
    fetchROs: RepairOrdersActionCreator.FetchROs,
    selectRO: RepairOrdersActionCreator.SelectRO,
    getROHistory: ROHistoryActionCreator.GetROHistory,
    setERAError: FrameworkActionCreator.SetERAError,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    toggleLocale: FrameworkActionCreator.setLocale,
    clearCustInfo: CustomerActionCreator.ClearCustInfo,
    clearVehicles: VehiclesActionCreator.ClearVehicles,
    clearNewVehicle: NewVehicleActionCreator.ClearNewVehicle,
    clearApptState: AppointmentActionCreator.ClearApptState,
    clearROState: RepairOrdersActionCreator.ClearROState,
    clearROHistory: ROHistoryActionCreator.ClearROHistory,
    clearMenusState: MenusActionCreator.ClearMenusState,
    clearTokenData: FrameworkActionCreator.ClearTokenData,
    getDocsROHistory: ROHistoryActionCreator.GetDocsROHistory,
    checkAuthToken: CustomerActionCreator.CheckAuthToken,
    checkAuthTokenOSD: CustomerActionCreator.CheckAuthOSDToken,
    logDocsHistory: RepairOrdersActionCreator.LogDocsHistory,
    setLoadingStateToIdle: CustomerActionCreator.SetLoadingStateToIdle,
    getMaintContracts: AdditionalServicesActionCreator.GetMaintContracts,
    setWaitOnRecall: FrameworkActionCreator.SetWaitOnRecall,
    setWaitOnMC: FrameworkActionCreator.SetWaitOnMC,
    setApptHistId: AppointmentActionCreator.SetApptHistId,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(LandingPage);